export default __webpack_public_path__ + "static/media/Silent Night.f14619ea.png";